<script setup lang="ts">
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import CreatePolicyDialog from '@/components/asicw/policies/create-dialog/CreatePolicyDialog.vue'
import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import PolicyGroupsTable from '@/components/rc/tables/PolicyGroupsTable.vue'
import { useOIDCStore } from '@/stores/oidc.store'

const { isASICWOperationalUser } = useOIDCStore()

const createDialogVisible = ref(false)
const policyGroupCreationDialogVisible = ref<boolean>(false)
</script>

<template>
  <ViewLayout>
    <CreatePolicyDialog v-model="createDialogVisible" />
    <PolicyGroupsTable>
      <template #controls>
        <el-button
          v-if="isASICWOperationalUser"
          :icon="Plus"
          type="primary"
          @click="policyGroupCreationDialogVisible = true"
          >Create new group</el-button
        >
      </template>
    </PolicyGroupsTable>
    <CreatePolicyDialog v-model="policyGroupCreationDialogVisible" />
  </ViewLayout>
</template>
